import { render, staticRenderFns } from "./Zoningmanagement.vue?vue&type=template&id=5b8f2eef&scoped=true&"
import script from "./Zoningmanagement.vue?vue&type=script&lang=js&"
export * from "./Zoningmanagement.vue?vue&type=script&lang=js&"
import style0 from "./Zoningmanagement.vue?vue&type=style&index=0&id=5b8f2eef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8f2eef",
  null
  
)

export default component.exports